import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';

@Component({
  selector: 'app-engineering-config',
  templateUrl: './engineering-config.component.html',
  styleUrls: ['./engineering-config.component.scss']
})
export class EngineeringConfigComponent implements OnInit, OnDestroy {

  constructor(private transferHttp: TransferHttpService
    , public permissions: PermissionsService) {
  }

  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;
  destroy$: Subject<boolean> = new Subject();
  @ViewChild('engConfigForm') engConfigForm: NgForm;

  defaultOverhead: number;
  defaultPayrollTax: number;
  defaultNonProd: number;

  //Spinner
  spinnerText: string = "Saving...";
  showSpinner: boolean = false;

  saveClick() {
    this.showSpinner = true;
    this.transferHttp.put(`ProjectSupport/SaveEngConfig?name=${EngConfig.DefaultOverhead}&value=${this.defaultOverhead}`, null).pipe(takeUntil(this.destroy$)).subscribe();
    this.transferHttp.put(`ProjectSupport/SaveEngConfig?name=${EngConfig.DefaultPayrollTax}&value=${this.defaultPayrollTax}`, null).pipe(takeUntil(this.destroy$)).subscribe();
    this.transferHttp.put(`ProjectSupport/SaveEngConfig?name=${EngConfig.DefaultNonProd}&value=${this.defaultNonProd}`, null).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.showSpinner = false;
    });
    this.engConfigForm.form.markAsPristine();
  }

  ngOnInit() {
    this.transferHttp.getSingle(`ProjectSupport/GetEngConfig?name=${EngConfig.DefaultOverhead}`).subscribe(d => this.defaultOverhead = d.configValue);
    this.transferHttp.getSingle(`ProjectSupport/GetEngConfig?name=${EngConfig.DefaultPayrollTax}`).subscribe(d => this.defaultPayrollTax = d.configValue);
    this.transferHttp.getSingle(`ProjectSupport/GetEngConfig?name=${EngConfig.DefaultNonProd}`).subscribe(d => this.defaultNonProd = d.configValue);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}

export enum EngConfig {
  DefaultOverhead = "DefaultOverhead",
  DefaultPayrollTax = "DefaultPayrollTax",
  DefaultNonProd = "DefaultNonProd"
}
